import { useState, useEffect } from "react";
import { Platform } from "react-native";

const getOrientation = () =>
  Platform.OS === "web" ? window.screen?.orientation?.type : undefined;

const useWebOrientation = () => {
  const [orientation, setOrientation] = useState(getOrientation);

  useEffect(() => {
    if (Platform.OS !== "web") return;

    const updateOrientation = () => {
      setOrientation(getOrientation());
    };

    window.addEventListener("orientationchange", updateOrientation);
    return () => {
      window.removeEventListener("orientationchange", updateOrientation);
    };
  }, []);

  return orientation;
};

export default useWebOrientation;
